import { ConstraintConfigurationInput } from '@occc/graphql';

export const makeRequiresActivationConstraintConfiguration = (
  allowMultipleFulfillmentsOnActivation: boolean,
  mustFulfillWithinDays: number | undefined,
) => {
  const configuration: ConstraintConfigurationInput = {
    requiresActivation: {
      allowMultipleFulfillmentsOnActivation,
      ...(typeof mustFulfillWithinDays === 'number' ? { mustFulfillWithinDays } : {}),
    },
  };
  return configuration;
};
